module.exports = __webpack_public_path__ + "img/thumbnail_Ocelot_m_normal.590f7705.png";